import React from 'react';
import { ButtonProps } from '@react-awesome-query-builder/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button as MuiButton, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';

type TypeToIcon = {
  [key: string]: React.ComponentElement<any, any>;
};
type TypeToColor = {
  [key: string]: string;
};

interface StyleProps {
  type: string;
}

const styles = ({ spacing }: Theme) =>
  createStyles<string, StyleProps>({
    root: {
      marginRight: ({ type }) => {
        if (['addRule', 'addGroup', 'delGroup'].includes(type)) {
          return spacing(1);
        }
      },
      '&:last-child': {
        marginRight: 0,
      },
    },
  });

const useStyles = makeStyles(styles);

export function Button(props: ButtonProps | undefined): React.ReactElement {
  if (!props) {
    return <></>;
  }
  const { type, onClick, label } = props;
  const classes = useStyles({ type });

  const typeToOnlyIcon: TypeToIcon = {
    delGroup: <FontAwesomeIcon icon={faTrash} />,
    delRule: <FontAwesomeIcon icon={faTrash} />,
    addRuleGroup: <FontAwesomeIcon icon={faPlus} />,
  };
  const typeToIcon: TypeToIcon = {
    addRule: <FontAwesomeIcon icon={faPlus} />,
    addGroup: <FontAwesomeIcon icon={faPlus} />,
  };
  const typeToColor: TypeToColor = {
    addRule: 'secondary',
    addGroup: 'secondary',
    addRuleGroup: 'secondary',
    delGroup: 'info',
    delRule: 'info',
  };

  const color = typeToColor[type as keyof TypeToColor];
  const onlyIcon = typeToOnlyIcon[type as keyof TypeToIcon];
  const icon = typeToIcon[type as keyof TypeToIcon];

  if (onlyIcon) {
    return (
      <MuiButton className={classes.root} onClick={onClick} color={color as any} variant="text">
        {onlyIcon}
      </MuiButton>
    );
  }

  return (
    <MuiButton className={classes.root} onClick={onClick} color={color as any} startIcon={icon}>
      {label}
    </MuiButton>
  );
}
